module.exports = __webpack_public_path__ + "media/img/illustrations/icons/notifications-inactive-5f709780b945eb24cdd03f8e289fe4c0.svg";